import React from "react";
import { Star } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const HeroBadge = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const badgeText =
    labels.menuPages?.howItWorks?.hero?.badge ||
    "Sveriges Smartaste Bilplattform";

  return (
    <div className="flex items-center justify-center lg:justify-start gap-2 mb-4 md:mb-6">
      <Star className="w-5 h-5 md:w-6 md:h-6 text-yellow-400 fill-current" />
      <span className="text-yellow-400 font-semibold text-sm md:text-base">
        {badgeText}
      </span>
      <Star className="w-5 h-5 md:w-6 md:h-6 text-yellow-400 fill-current" />
    </div>
  );
};

export default HeroBadge;
